<template>
  <div>
    <h4>审批进度</h4>
    <el-steps v-if="steps.length > 0" :active="stepActive" finish-status="success" align-center>
      <el-step v-for="(item, index) in steps" :key="index">
        <span style="font-size: 14px" slot="title">{{ item }}</span>
      </el-step>
    </el-steps>
    <div style="height: 10px"></div>

    <div class="input-item-box">
      <span class="input-description-long">审批结果:</span>
      <el-input size="mini" :placeholder="pendingResult" :disabled="true" class="input-long"></el-input>
    </div>
    <div class="input-item-box">
      <span class="input-description-long">审批时间:</span>
      <el-input size="mini" :placeholder="pendingTime" :disabled="true" class="input-long"></el-input>
    </div>
    <div style="height: 10px"></div>

    <el-table :data="pendingDetail" v-if="pendingDetail.length > 0" border>
      <el-table-column prop="pendingEmployee" label="审批人" width="120"></el-table-column>
      <el-table-column prop="pendingResult" label="审批结果" width="100"></el-table-column>
      <el-table-column prop="pendingTime" label="审批时间" width="140"></el-table-column>
      <el-table-column prop="pendingInfo" label="审批意见"></el-table-column>
    </el-table>

  </div>
</template>

<script>
export default {
  name: 'PendingProgressView',

  props: ['pendingProgressData', "applyData"],

  mounted() {
    // this.loadTestData()
    this.loadData()
  },

  data() {
    return {
      pendingResult: "", // 审批结果
      pendingEmployee: "", // 审批员工
      pendingTime: "", // 审批时间
      pendingComments: "", // 审批备注

      pendingDetail: [],
      steps: [],
      stepActive: 0,

    };
  },

  watch: {
    "pendingProgressData": function (val, oldVal) {
      this.loadData()
    },
    "applyData": function (val, oldVal) {
      this.loadData()
    }

  },

  methods: {
    loadData() {
      this.steps = []
      this.pendingDetail = []
      this.pendingResult = ""
      this.pendingTime = ""
      this.pendingComments = ""
      this.stepActive = 0

      if (this.pendingProgressData != null && this.pendingProgressData.length > 0) {
        this.steps = []
        this.pendingDetail = []
        this.steps.push("开始")
        this.pendingProgressData.forEach(item => {
          this.steps.push(item.employeeName)
          let pendingResult = ""

          if (item.result === "PASS") {
            pendingResult = "审批通过"
          } else if (item.result === "WAITING") {
            pendingResult = "审批中..."
          } else {
            pendingResult = "审批拒绝"
          }

          this.pendingDetail.push({
            pendingEmployee: item.employeeName,
            pendingResult: pendingResult,
            pendingTime: this.getShowTime(item.updateTime),
            pendingInfo: item.comments
          })
        })
        this.steps.push("结束")
      }

      this.stepActive = this.applyData.currentStep
      switch (this.applyData.state) {
        case "PASS":
          if (this.pendingProgressData.length > 0) {
            this.pendingResult = "审批通过"
            this.pendingTime = this.getShowTime(this.pendingProgressData[this.applyData.currentStep - 1].updateTime)
            this.pendingEmployee = this.pendingProgressData[this.applyData.currentStep - 1].employeeName
            this.pendingComments = this.pendingProgressData[this.applyData.currentStep - 1].comments
          } else {
            this.pendingResult = "免审通过"
            this.pendingTime = this.getShowTime(this.applyData.createTime);
          }
          this.stepActive = this.steps.length
          break
        case "REJECT":
          this.pendingResult = "审批拒绝";
          this.pendingTime = this.getShowTime(this.pendingProgressData[this.applyData.currentStep - 1].updateTime);
          this.pendingComments = this.pendingProgressData[this.applyData.currentStep - 1].comments;
          this.pendingEmployee = this.pendingProgressData[this.applyData.currentStep - 1].employeeName
          break
        case "CANCEL":
          this.pendingResult = "撤销申请"
          break
        case "PROCESS":
          this.pendingResult = "审批中..."
          break
        case "NONE":
          this.pendingResult = "审批中..."
          break
      }
    },

    getShowTime(value) {
      if (value == null) {
        return
      }
      return value.substring(2, 10) + ' ' + value.substring(11, 16)
    },
    loadTestData() {
      this.pendingResult = "同意"
      this.pendingTime = "2019-01-01 12:00:00"
      this.pendingDetail = [
        {
          pendingEmployee: "张三",
          pendingResult: "同意",
          pendingTime: "2019-01-01 12:00:00",
          pendingInfo: "同意"
        },
        {
          pendingEmployee: "张三",
          pendingResult: "同意",
          pendingTime: "2019-01-01 12:00:00",
          pendingInfo: "同意"
        }
      ]
      this.steps = ["开始", "张三", "结束"]
      this.stepActive = 0
    }
  }
}

</script>

<style scoped lang="less">

.drawer-title {
  padding-left: 10px;
  padding-top: 10px;
}

.input-short {
  width: 150px;
}

.input-long {
  width: 300px;
}

.grid-content {
  //padding-left: 8px;
  margin: 8px 8px 8px 20px;

}

.input-item-box {
  padding-bottom: 8px;
  display: flex;
  flex-direction: row;

  justify-content: start;
  align-items: center;
}

.input-description {
  display: inline-block;
  width: 80px;
}

.input-description-long {
  display: inline-block;
  width: 120px;
}


</style>
